import React from "react";
import Tabs from "../../Components/Tabs";
import Photos from "./Photos";
import GoogleCalendarAuth from "../../Components/GoogleCalendarAuth";
import ShoppingListEditor from "./ShoppingListEditor";
import SpotifyAuth from "../../Components/SpotifyAuth";
import RingAuth from "./RingAuth";
import Button from "../../Components/BulletButton";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router";

type Props = {};

export default function Admin({}: Props) {
  const navigate = useNavigate();
  return (
    <>
      <Tabs
        tabTitles={["Photos", "Calendar", "Shopping", "Spotify", "Ring"]}
        tabContents={[
          <Photos />,
          <GoogleCalendarAuth
            clientId={process.env.REACT_APP_GOOGLE_CAL_CLIENT_ID!}
          />,
          <ShoppingListEditor />,
          <SpotifyAuth clientId={process.env.REACT_APP_SPOTIFY_CLIENT_ID!} />,
          <RingAuth />,
        ]}
      />
      <Button className="home-btn" onClick={() => navigate("/")}>
        <FontAwesomeIcon icon={faHome} />
      </Button>
    </>
  );
}
